<template>
  <div class="tw-mx-4 tw-py-4">
    <div class="tw-grid tw-grid-cols-10 tw-gap-5">
      <div class="tw-col-span-2 tw-space-y-3">
        <GameSearchFilters></GameSearchFilters>
      </div>
      <div class="tw-space-y-3 tw-col-span-8">
        <CasinoTabs
          :casinoProviders="casinoProviders"
          :selectedProvider="selectedProvider"
          @onGoToCasino="goToCasino"
        ></CasinoTabs>

        <div class="grid-games" v-if="!loading">
          <div v-for="(game, i) in gameList" :key="i">
            <v-menu
              :close-on-content-click="false"
              :nudge-width="100"
              offset-x
              open-delay="400"
              close-delay="200"
              transition="scale-transition"
              :open-on-hover="true"
            >
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs" v-on="on">
                  <div>
                    <v-img
                      :class="`tw-flex tw-items-end tw-rounded-md ${
                        game.saved ? 'tw-border-4 shadow tw-border-blue-500' : ''
                      }`"
                      :src="game.image"
                      min-height="186"
                    >
                      <template v-slot:placeholder>
                        <v-sheet>
                          <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
                        </v-sheet>
                      </template>
                      <div
                        class="tw-text-white tw-text-sm tw-bg-gray-700 py-2 tw-flex tw-justify-between px-2 tw-items-center"
                      >
                        <div>
                          {{ game.name }} <span>{{ game.has_lobby ? "(lobby)" : "" }}</span>
                          {{ game.has_tables ? "(has tables)" : "(no tables)" }}
                        </div>
                        <div v-if="!!game.saved" class="tw-bg-blue-500 tw-rounded-full">
                          <v-icon>mdi-check-circle</v-icon>
                        </div>
                        <div v-else class="tw-px-4 tw-py-3"></div>
                      </div>
                    </v-img>
                  </div>
                </a>
              </template>
              <v-card>
                <div class="tw-p-3">
                  <div class="tw-text-xl tw-font-bold text-left">
                    {{ game.name }}
                  </div>
                  <v-divider></v-divider>

                  <ul class="text-left py-2 tw-list-disc">
                    <li class="tw-text-sm">UUID : {{ game.uuid }}</li>
                    <li class="tw-text-sm">Type : {{ game.type }}</li>
                    <li class="tw-text-sm">Technology : {{ game.technology }}</li>
                    <li class="tw-text-sm">Provider : {{ game.provider }}</li>
                    <li class="tw-text-sm">Is Mobile : {{ game.is_mobile ? "Yes" : "No" }}</li>
                    <li class="tw-text-sm">Has Tables : {{ game.has_tables ? "Yes" : "No" }}</li>
                    <li class="tw-text-sm">Has Lobby : {{ game.has_lobby ? "Yes" : "No" }}</li>
                    <li class="tw-text-sm">Has Free Spins : {{ game.has_freespins ? "Yes" : "No" }}</li>
                    <li class="tw-text-sm">
                      Free Spin Valid Until Full Day : {{ game.freespin_valid_until_full_day ? "Yes" : "No" }}
                    </li>
                  </ul>
                </div>
              </v-card>
            </v-menu>
          </div>
        </div>
        <div class="tw-flex tw-items-center tw-justify-between">
          <div class="text-left tw-p-3 tw-text-white tw-flex tw-items-center tw-space-x-3">
            <v-btn class="primary" @click="saveAllToGameDetails">Add all items in this page</v-btn>
          </div>
          <v-pagination
            v-if="pageCount > 1"
            :total-visible="7"
            v-model="page"
            :length="pageCount"
            circle
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// new AWN().success('Custom success message', {durations: {success: 0}})

// @ is an alias to /src
import { mapActions, mapMutations, mapState } from "vuex";
import GameSearchFilters from "../../components/GameSearchFilters.vue";
import CasinoTabs from "../../components/admin/CasinoTabs.vue";
export default {
  name: "Home",
  props: ["casinoProviders"],
  components: {
    GameSearchFilters,
    CasinoTabs,
  },
  data: () => ({
    page: 1,
    loading: false,
    gameList: [],
    selectedProvider: "Slotegator",
  }),
  async mounted() {
    this.selectedProvider = this.$route.query.casinoprovider || "Slotegator";
    this.loadGames();
  },

  computed: {
    ...mapState("game", ["adminGames"]),
    metaData() {
      return this.adminGames._meta && this.adminGames._meta;
    },
    currentPage() {
      return this.metaData && this.metaData.currentPage && this.metaData.currentPage;
    },
    pageCount() {
      return this.metaData && this.metaData.pageCount && (this.metaData.pageCount || 1);
    },
    perPage() {
      return this.metaData && this.metaData.perPage && this.metaData.perPage;
    },
    totalCount() {
      return this.metaData && this.metaData.totalCount && this.metaData.totalCount;
    },
    selectedPage() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    async page() {
      await this.$router.push({
        path: "/admin/games",
        query: { ...this.$route.query, page: this.page },
      });
      await this.initGames({
        selectedPage: this.selectedPage,
        selectedProvider: this.selectedProvider,
      });
      await this.validateGames();
    },
    async selectedProvider() {
      await this.loadGames();
    },
  },
  methods: {
    ...mapActions("game", ["getAdminGames", "saveGameDetails", "getGameDetailsSaved"]),
    async loadGames() {
      this.page = this.$route.query.page || 1;
      this.page = parseInt(this.page);
      this.loading = true;
      await this.initGames({
        selectedPage: this.selectedPage,
        selectedProvider: this.selectedProvider,
      });
      await this.validateGames();
      this.loading = false;
    },
    async initGames(selected = null) {
      await this.getAdminGames(selected);
      this.gameList = (this.adminGames && this.adminGames.items && (this.adminGames.items || [])) || [];
    },
    async validateGames() {
      const savedGames = await this.getGameDetailsSaved(this.gameList.map((game) => game.uuid));
      this.gameList = this.gameList.map((game) => {
        const saved = savedGames.find((saved) => saved.uuid == game.uuid);
        if (saved) {
          game.game_type = saved.game_type;
          game.saved = true;
        }
        return game;
      });
    },
    goToCasino(provider) {
      this.gameList = [];
      this.selectedProvider = provider;
      this.$router.push({
        path: "/admin/games",
        query: { casinoprovider: provider },
      });
    },
    goToCasinoGames() {
      this.$router.push("/admin/casino-games");
    },
    async saveAllToGameDetails() {
      this.gameList.map(async (game) => {
        await this.saveGameDetails({
          ...game,
          main_provider: this.selectedProvider,
        });
      });
      this.$toast.success("Games in this page saved successfully", {
        position: "bottom-right",
        timeout: 2815,
        closeOnClick: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: false,
        icon: true,
        rtl: false,
      });
    },
  },
};
</script>

<style scoped></style>
